import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const ContainerForm = styled.div`
    display: flex;
    flex-direction: column;
    gap: .8rem;
    width: 100%;
    padding: .5rem;
    margin-top: .8rem; 
    
    span{
        color: red;
    }
`
export const CustomButton = styled(ButtonMui)`
    height: 3rem !important;
    margin: 0 !important;
`
export const CustomTextField = styled(TextFieldMui)`
    height: 3rem !important;
    margin: 0 !important;

    & input {
        height: 1.5rem !important;
    }
`
